module.exports = __webpack_public_path__ + "img/circular-label-with-certified-stamp.b5c5fca3.png";